import * as zod from 'zod';

import { ArmPosition } from '@sb/routine-runner/types';
import { LocateResult } from '@sb/routine-runner/vision/LocateTypes';

export default zod.object({
  latestResult: zod.array(ArmPosition).nullable(),
  resultCount: zod.number(),
  latestSaveFilepath: zod.string().nullable(),
  captureTimestamp: zod.string().nullable(),
  fullResults: zod.array(LocateResult).nullable(),
});
